/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    ALL_BACK: 'ALL_BACK',
    NOT_PAID: 'NOT_PAID',
    AGREE_UNPAID_STORNO: 'AGREE_UNPAID_STORNO',
    STANDARD_STORNO: 'STANDARD_STORNO',
};
